export const searchHistoryConstants = {
  OLD_KEY: 'history',
  KEY: 'search_history_20241402'
};
